import { fetchAdminDonations } from '../../util/api';

// ================ Action types ================ //

export const FETCH_DONATIONS_REQUEST = 'app/AdminDonationsPage/FETCH_DONATIONS_REQUEST';
export const FETCH_DONATIONS_SUCCESS = 'app/AdminDonationsPage/FETCH_DONATIONS_SUCCESS';
export const FETCH_DONATIONS_ERROR = 'app/AdminDonationsPage/FETCH_DONATIONS_ERROR';

// ================ Reducer ================ //

const initialState = {
  donations: [],
  fetchInProgress: false,
  fetchError: null,
};

export default function adminDonationsPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_DONATIONS_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_DONATIONS_SUCCESS:
      return { ...state, fetchInProgress: false, donations: payload };
    case FETCH_DONATIONS_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, fetchInProgress: false, fetchError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchDonationsRequest = () => ({ type: FETCH_DONATIONS_REQUEST });
export const fetchDonationsSuccess = donations => ({
  type: FETCH_DONATIONS_SUCCESS,
  payload: donations,
});
export const fetchDonationsError = e => ({
  type: FETCH_DONATIONS_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

export const queryDonations = () => dispatch => {
  dispatch(fetchDonationsRequest());
  return fetchAdminDonations()
    .then(response => {
      dispatch(fetchDonationsSuccess(response.donations));
      return response;
    })
    .catch(e => {
      dispatch(fetchDonationsError(e));
      throw e;
    });
};

export const loadData = () => dispatch => {
  return dispatch(queryDonations());
};
